import { useState } from "react";
import { CA, BUY_URL, LOGO_URL, X_URL } from "@/lib/constants";
import { Copy, Check, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const XLogo = ({ size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Hero = () => {
  const [copied, setCopied] = useState(false);

  const copyCA = async () => {
    try {
      await navigator.clipboard.writeText(CA);
      setCopied(true);
      toast.success("CA copied. now go say it.");
      setTimeout(() => setCopied(false), 1800);
    } catch (e) {
      toast.error("couldn't copy. select it manually.");
    }
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative z-10 px-4 sm:px-8 lg:px-12 pt-8 pb-16"
    >
      <div className="max-w-7xl mx-auto">
        {/* Logo + Big title */}
        <div className="grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 order-2 lg:order-1">
            <h1
              data-testid="hero-title"
              className="font-bangers leading-[0.85] text-black"
              style={{ fontSize: "clamp(56px, 12vw, 200px)" }}
            >
              The Official
              <br />
              <span
                className="inline-block"
                style={{
                  color: "#0057FF",
                  WebkitTextStroke: "3px #000",
                }}
              >
                Dat Bih Gah
              </span>
              <br />
              Coin.
            </h1>

            <p
              data-testid="hero-tagline"
              className="font-luckiest text-lg sm:text-xl mt-6 max-w-xl text-black/80"
            >
              <span style={{ color: "#0057FF" }}>$DATBIHGAH</span> — the sound, the
              face, the whole reaction. when something hit different and all you can
              say is dat bih TUH or dat bih GAH.
            </p>

            {/* CA + Buy */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
              <button
                type="button"
                data-testid="hero-copy-ca"
                onClick={copyCA}
                className="sticker flex items-center gap-3 px-4 py-3 text-left hover:bg-[#f7f7f7] transition-colors"
              >
                <span className="tag text-xs">CA</span>
                <span className="font-mono text-xs sm:text-sm truncate max-w-[200px] sm:max-w-[280px]">
                  {CA}
                </span>
                {copied ? (
                  <Check size={18} className="shrink-0" />
                ) : (
                  <Copy size={18} className="shrink-0" />
                )}
              </button>

              <a
                data-testid="hero-buy-button"
                href={BUY_URL}
                target="_blank"
                rel="noreferrer"
                className="btn-chunky text-base sm:text-lg"
              >
                BUY $DATBIHGAH <ArrowRight size={18} />
              </a>
            </div>

            {/* Social icon button */}
            <div className="mt-4 flex items-center gap-3">
              <a
                data-testid="hero-x-button"
                href={X_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="X"
                className="btn-chunky btn-black !p-3"
              >
                <XLogo size={20} />
                <span className="font-luckiest text-sm">FOLLOW ON X</span>
              </a>
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 font-luckiest text-sm sm:text-base">
              <span className="flex items-center gap-2">
                <span
                  className="inline-block w-2 h-2 rounded-full"
                  style={{ background: "#0057FF" }}
                />
                Two sounds. One whole movement.
              </span>
              <span className="flex items-center gap-2">
                <span className="inline-block w-2 h-2 rounded-full bg-black" />
                We&apos;re still early
              </span>
            </div>
          </div>

          {/* Logo card */}
          <div className="lg:col-span-5 order-1 lg:order-2 flex justify-center">
            <div className="relative sticker p-4 sm:p-6 w-full max-w-md float-y">
              <img
                src={LOGO_URL}
                alt="$DATBIHGAH logo"
                data-testid="hero-logo"
                className="w-full h-auto block"
              />
              <div className="absolute -top-3 -left-3 tag text-xs">THE FACE</div>
              <div
                className="absolute -bottom-3 -right-3 tag text-xs"
                style={{ background: "#0057FF", color: "#fff", border: "2px solid #000" }}
              >
                $DATBIHGAH
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
